import {
    OPEN_OVERLAY,
    CLOSE_OVERLAY,
} from 'vue/vuex/mutation-types';


export function openOverlay({ commit }, { facet, isOpen, component, props }) {
    document.activeElement.blur();
    commit(OPEN_OVERLAY, { facet, isOpen, component, props });
}

export function closeOverlay({ commit }, { transition }) {
    commit(CLOSE_OVERLAY, { transition });
}



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/vuex/modules/overlay/actions.js